import { CAPABILITY } from "../../../helpers/permissions";
import { loadScopedAccountsPayableTimelogs } from "../../../helpers/scopedQueries";
import { computePayrollLiabilityTotals } from "../../../helpers/payrollHelpers";
import { buildGuestExecutiveBriefingData } from "../executiveBriefingGuestDemo";
import { formatBriefingCurrency, pluralize } from "../formatBriefingSpeech";

export const ACCOUNTS_PAYABLE_PROVIDER_ID = "accountsPayable";

async function loadPayablesSnapshot(ctx) {
  if (ctx.isGuest) {
    return buildGuestExecutiveBriefingData().accountsPayable;
  }

  if (ctx.isOffline || !ctx.actor) {
    return null;
  }

  const rows = await loadScopedAccountsPayableTimelogs(
    ctx.supabaseClient,
    ctx.actor,
    ctx.scopeContext,
  );

  const unpaidRows = (rows || []).filter((row) => row.payroll_status !== "paid");
  const liabilityTotals = computePayrollLiabilityTotals(
    unpaidRows,
    ctx.orgSettings,
  );

  return {
    payrollLiability: liabilityTotals.grossPay,
    unpaidEntries: unpaidRows.length,
  };
}

export const accountsPayableProvider = {
  id: ACCOUNTS_PAYABLE_PROVIDER_ID,
  isEligible(ctx) {
    return ctx.can(CAPABILITY.ACCOUNTS_PAYABLE_VIEW);
  },
  loadData: loadPayablesSnapshot,
  buildSection(_ctx, data) {
    if (!data) {
      return null;
    }

    const { payrollLiability, unpaidEntries } = data;

    if (unpaidEntries <= 0) {
      return "Payroll liability is clear — nothing waiting to be paid out.";
    }

    const liabilityPhrase = formatBriefingCurrency(payrollLiability);
    const entryPhrase = pluralize(unpaidEntries, "unpaid payroll entry", "unpaid payroll entries");

    if (liabilityPhrase) {
      return `Payroll liability stands at ${liabilityPhrase} across ${entryPhrase}.`;
    }

    return `You have ${entryPhrase} in the payroll queue.`;
  },
};
